/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetPlannedServicesForEmployeeAndDateIdDateGet$Params {
  id: number;
  date: string;
}

export function getPlannedServicesForEmployeeAndDateIdDateGet(http: HttpClient, rootUrl: string, params: GetPlannedServicesForEmployeeAndDateIdDateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getPlannedServicesForEmployeeAndDateIdDateGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

getPlannedServicesForEmployeeAndDateIdDateGet.PATH = '/GetPlannedServicesForEmployeeAndDate/{id}/{date}';
